export default {
  namespaced: true,
  state: {
    topics: [
      {
        Name: 'Chương 1 - Khái quát về phân số',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 2 - Hình học',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 3 - Khối lập phương',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 4 - Căn bậc hai',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 5 - Hằng đẳng thức',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 6 - Căn bậc ba',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 7 - Ôn tập học kì I',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      },
      {
        Name: 'Chương 8 - Ôn tập học kì II',
        Lesson: [
          {
            Name: 'Hình học phẳng'
          },
          {
            Name: 'Hình không gian'
          },
          {
            Name: 'Hình học phẳng'
          }
        ]
      }
    ],

    exercises: [
      {
        Name: '50 câu hỏi phân số',
        Image: require('@/assets/images/png/documents/1.png')
      },
      {
        Name: '50 câu hỏi đồ thị hàm số',
        Image: require('@/assets/images/png/documents/2.png')
      }
    ],

    lessons: [
      {
        Name: 'Phép cộng 2 phân số',
        Image: require('@/assets/images/png/documents/1.png')
      },
      {
        Name: 'Phép nhân 2 phân số',
        Image: require('@/assets/images/png/documents/2.png')
      }
    ]
  }
}
